export const FIXED_MODAL_TOP_OFFSET = 80
export const FIXED_MODAL_BOTTOM_GAP = 16

export const fixedModalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'flex-start',
    paddingTop: FIXED_MODAL_TOP_OFFSET,
    paddingBottom: FIXED_MODAL_BOTTOM_GAP,
}
